import { render, staticRenderFns } from "./box-detail.vue?vue&type=template&id=55116e04&"
import script from "./box-detail.vue?vue&type=script&lang=js&"
export * from "./box-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports